import { render, staticRenderFns } from "./AbTags.vue?vue&type=template&id=05ab555e&scoped=true"
import script from "./AbTags.vue?vue&type=script&lang=js"
export * from "./AbTags.vue?vue&type=script&lang=js"
import style0 from "./AbTags.vue?vue&type=style&index=0&id=05ab555e&prod&scoped=true&lang=scss"
import style1 from "./AbTags.vue?vue&type=style&index=1&id=05ab555e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab555e",
  null
  
)

export default component.exports